// import { DownloadOutlined } from '@ant-design/icons';
import styled from 'styled-components';

import { VFlex } from '@/components/base';
// import IconButton from '@/components/Button/IconButton';
import Typo, { SpanStyle } from '@/components/Typography/Typo';

export const ContentBox = styled(VFlex)`
  width: 100%;
  border: 1px solid ${(props) => props.theme.colors.gray300};
  border-radius: 20px;
`;

export const ContentHeader = styled(Typo)`
  ${SpanStyle({
    type: 'label0',
    weight: 'm',
  })};
  color: ${(props) => props.theme.colors.gray800};
`;

export const DownloadButton = (props: {
  onClick?: () => void;
  disabled?: boolean;
}) => {
  return null;
  // return (
  //   <IconButton
  //     icon={<DownloadOutlined />}
  //     sizeType="s"
  //     onClick={props.onClick}
  //     disabled={props.disabled}
  //   />
  // );
};

const SearchContentStyles = {
  ContentBox,
  ContentHeader,
  DownloadButton,
};

export default SearchContentStyles;
